/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable no-restricted-imports */

import cn from "classnames";
import { List as MaterialList } from "material-ui";
import * as React from "react";
import ActionList from "~/components/ActionList";
import { BaseComponent } from "~/components/BaseComponent/BaseComponent";
import BorderedListItem from "~/components/BorderedListItem";
import IconButton from "~/components/IconButton";
import { Icon } from "~/components/IconButton/IconButton";
const styles = require("./style.less");

interface RemoveItemsListProps<R> {
    empty?: React.ReactNode;
    data: R[];
    clearButtonToolTip?: string;
    listActions?: React.ReactElement[];
    onRow(item: R, idx: number): React.ReactNode;
    onRowTouch?(item: R): void;
    onRemoveRow?(item: R): void;
    removeButtonAccessibleName?(item: R, index: number): string;
}

export abstract class RemoveItemsList<R> extends BaseComponent<RemoveItemsListProps<R>, {}> {
    private bottomActionVisibilityThreshold = 3;

    constructor(props: RemoveItemsListProps<R>) {
        super(props);
    }

    render() {
        const actions = (this.props.listActions || []).map((action, index) => React.cloneElement(action, { key: index }));
        const actionList = <ActionList actions={actions} />;
        return (
            <div>
                <div className={styles.actionsMenu}>{actionList}</div>
                {this.props.data.length === 0 && this.props.empty && <div className={styles.emptyList}>{this.props.empty}</div>}
                {this.props.data.length !== 0 && <MaterialList>{this.props.data.map((item, index) => this.buildItem(item, index))}</MaterialList>}
                <div className={cn(styles.actionsMenu, { [styles.hidden]: this.props.data.length < this.bottomActionVisibilityThreshold })}>{actionList}</div>
            </div>
        );
    }

    private buildItem(item: R, index: number) {
        const clearButton = this.props.onRemoveRow ? (
            <IconButton
                toolTipContent={this.props.clearButtonToolTip}
                onClick={(e) => {
                    e.stopPropagation();
                    this.props.onRemoveRow!(item);
                }}
                icon={Icon.Cancel}
                accessibleName={this.props.removeButtonAccessibleName?.(item, index)}
                style={{ marginRight: "0.8rem", marginTop: "0.8rem" }}
            />
        ) : null;

        return (
            <BorderedListItem key={this.getKey(item, index)} rightIconButton={clearButton} onClick={this.props.onRowTouch ? () => this.onTouch(item) : null} disabled={this.props.onRowTouch ? false : true}>
                {this.props.onRow(item, index)}
            </BorderedListItem>
        );
    }

    private getKey(item: R | { Id: number }, index: number): string | number {
        const converted = item as object;
        return converted && converted.hasOwnProperty("Id") ? (item as { Id: number }).Id : index;
    }

    private onTouch(item: R) {
        if (this.props.onRowTouch) {
            this.props.onRowTouch(item);
        }
    }
}
